export default function Column_Charts() {
  return <div>Excel_Column_Charts</div>;
}
